import React from 'react';

const Diploma = () => {
    return (
        <div className="programme-details">
            <div className="programme-title">
                <h2>Diploma - Programme</h2>
            </div>
            <div className="programme-descripttion">
                <h3>What is Diploma Course ?</h3>
                <p>A diploma is a certificate or deed issued by an educational institution, such as college or university, that testifies that the recipient has successfully completed a particular course of study. The word diploma also refers to an academic award which is given after the completion of study in different courses such as diploma in higher education, diploma in graduation or diploma in post-graduation. Historically, it can also refer to a charter or official document.The diploma (as a document certifying a qualification) may also be called a testamur.</p>
                <h3>Our Diploma Programes : </h3>
                <ul>
                    <li>Aviation Management .</li>
                    <li>Aircraft Maintenance Engineering .</li>
                    <li>Air Traffic Control System</li>
                    <li>Airport Management</li>
                    <li>Mechatronics .</li>
                    <li>Nano - Technology .</li>
                </ul>
                <h3>Duration : </h3>
                <ul>
                    <li>Full Course 3 Years .</li>
                    <li>6 Month (each semester) .</li>
                </ul>
                <h3>What is the Pre-requerments for this course ?</h3>
                <ul>
                    <li>Must Needed English proficiency Certificate (IELTS, TOFEL, DUOLINGO etc) .</li>
                    <li>10th class or equivalente certificate .</li>
                    <li>Each subject minimum had 65% markes .</li>
                </ul>
            </div>
        </div>
    );
};

export default Diploma;